import React from 'react'

const ButtonGasco = () => {


  const handleClick = () => {
    console.log('Clicked');
  }
  
  return (
    <gasco-button className='button__gasco'
                    color='sencodary'
                    disabled={false}
                    size='large'
                    strong={true}
                    fill='solid'
                    shape='round'
                    progress={false}
                    type='button'
                    buttonType='button'
                    onClick={handleClick}
                    style={{fontFamily:'fantasy'}}

      >
        Hola Buton gasco
      </gasco-button>
  )
}
export default ButtonGasco